export default {
    binEditor: {
        dstBanner: {
            spring: 'Daylight saving time begins. This day has 92 bins (clocks spring forward 02:00 → 03:00).',
            autumn: 'Daylight saving time ends. This day has 100 bins (clocks fall back 03:00 → 02:00).',
        },
        dayPosition: 'Day {current} of {total}',
        binsLabel: 'Bins',
        binCount: {
            spring: '{count} (DST spring forward)',
            autumn: '{count} (DST autumn fallback)',
            normal: '{count} (normal)',
        },
        daySum: 'Day sum',
        dirty: 'dirty',
        copyDay: 'Copy this day to other days...',
        resetDay: 'Reset day',
    },
}
